import React from 'react';
import PropTypes from 'prop-types';
import MenuBox from './MenuBox';
import DataCanvasContainer from './DataCanvasContainer';
import MemberButtonBox from './MemberButtonBox';
import error from './imagenotthere.png';

/**
 * Main stores the processed app state. Renders two MenuBox and a DataCanvasContainer
 */
export default class Main extends React.Component {
  state = this.props.initialState;

  /** Get the source string for the selected image.
   *
   * @param {string} unit - optional, a newly selected unit
   * @return {string} path to the image product that has been selected
   */
  getSource = unit => {
    // return("../newse_images/"
    return (
      'https://wof.nssl.noaa.gov/newse_images/' +
      this.state.selectedDate +
      '/' +
      this.state.selectedCycle +
      '/' +
      this.state.selectedField +
      '_f' +
      (unit || this.state.selectedUnit) +
      '.png'
    );
  };

  /** do a quick swap of the domainImg if true
   * when the bool is false, put the former product back
   * @param {boolean} bool - weather or not the Domain of the Day button
   * has been selected
   */
  handleDomainOftheDay = bool => {
    if (bool) {
      // create a product string based on the selected date
      let product = `NEWSe_domain_${this.state.selectedDate}`;
      // update the browser query string
      const newQueryString = `?d=${this.state.selectedDate}&f=NEWSe_domain`;
      window.history.pushState(null, null, newQueryString);
      // create the img element we need to swap with the current one in the DataCanvas
      const domainImg = (
        <img
          src={`../newse_images/${this.state.selectedDate}/${product}.png`}
          alt="Domain of the Day"
          onError={e => {
            e.target.src = error;
          }}
        />
      );
      // store the previous unit type so we can reset the unit buttons correctly later in DataCanvasContainer
      let prevUnitType = this.state.selectedFieldUnitType;
      // push to state data about domain and the previous unit type
      this.setState({ selectedFieldUnitType: 'full', prevUnitType, domainImg });
    } else {
      const newQueryString = `?d=${this.state.selectedDate}&c=${
        this.state.selectedCycle
      }&f=${this.state.selectedField}`;
      const domainImg = (
        <img
          src={this.getSource()}
          alt="Forecast"
          onError={e => {
            e.target.src = error;
          }}
        />
      );
      window.history.pushState(null, null, newQueryString);
      this.setState({
        domainImg,
        selectedFieldUnitType: this.state.prevUnitType
      });
    }
  };

  /**  update the state and the query string in the url without refreshing the app
   * the domainImg is set to null so the DataCanvasContainer will know to prefer the images preloaded there
   * @param {string} newDate  - the most recently selected date
   */
  handleDateChange = newDate => {
    this.setState({ selectedDate: newDate, domainImg: null });
    const newQueryString = `?d=${newDate}&c=${this.state.selectedCycle}&f=${
      this.state.selectedField
    }`;
    window.history.pushState(null, null, newQueryString);
  };

  /**  update the state and the query string in the url without refreshing the app
   * the domainImg is set to null so the DataCanvasContainer will know to prefer the images preloaded there
   * @param {string} newCycle - the most recently selected cycle
   */
  handleCycleChange = newCycle => {
    this.setState({ selectedCycle: newCycle, domainImg: null });
    const newQueryString = `?d=${this.state.selectedDate}&c=${newCycle}&f=${
      this.state.selectedField
    }`;
    window.history.pushState(null, null, newQueryString);
  };

  /**  update the state and the query string in the url without refreshing the app
   * the domainImg is set to null so the DataCanvasContainer will know to prefer the images preloaded there
   * @param {string} newField - the most recently selected field
   * @param {string} unit - the unit type for this field
   */
  handleFieldChange = (newField, unit) => {
    this.setState({
      selectedField: newField,
      selectedFieldUnitType: unit,
      selectedUnit: unit ? this.props.data.units[unit].start : '000',
      domainImg: null
    });
    const newQueryString = `?d=${this.state.selectedDate}&c=${
      this.state.selectedCycle
    }&f=${newField}`;
    window.history.pushState(null, null, newQueryString);
  };

  /**
   * the unit is the f number following the field/product name
   * update the state and the query string in the url without refreshing the app
   * the domainImg is set to null so the DataCanvasContainer will know to prefer the images preloaded there
   * @param {string} newUnit - the most recently selected unit
   */
  handleUnitChange = newUnit => {
    this.setState({ selectedUnit: newUnit, domainImg: null });
  };

  render() {
    return (
      <div className="main">
        <MenuBox
          data={this.props.data}
          dates={this.props.dates}
          selectedDate={this.state.selectedDate}
          handleDateChange={this.handleDateChange}
          handleCycleChange={this.handleCycleChange}
          handleFieldChange={this.handleFieldChange}
          handleDomainOftheDay={this.handleDomainOftheDay}
        />

        <DataCanvasContainer
          getSource={this.getSource}
          handleUnitChange={this.handleUnitChange}
          units={this.props.data['units']}
          unitType={
            !!this.state.selectedFieldUnitType
              ? this.state.selectedFieldUnitType
              : 'minutes'
          }
          unitThreashold={
            this.props.data['cycles'][this.state.selectedCycle][
              !!this.state.selectedFieldUnitType
                ? this.state.selectedFieldUnitType
                : 'minutes'
            ]
          }
          product={this.state.selectedField}
          cycle={this.state.selectedCycle}
          date={this.state.selectedDate}
          domainImg={this.state.domainImg}
        />

        <div className="menu-box">
          <MemberButtonBox
            classname="members"
            onEvent={this.handleFieldChange}
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  // data is from a json file structured specifically to populate
  // wof-essential menus. cycles, units, and fields are all included in the json
  data: PropTypes.object.isRequired,
  // an array of date strings is taken from a directory list
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  // if the app is navigated to using query strings, the intial state
  // will refelct those choices (if they are formatted correctly)
  initialState: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/Main.js